/* ============================================
   BLENDSCO CUSTOM JAVASCRIPT
   ============================================ */

(function() {
  'use strict';

  /* --- Marquee Duplication --- */
  function initMarquee() {
    const tracks = document.querySelectorAll('.blendsco-marquee__track');
    tracks.forEach(track => {
      const items = track.innerHTML;
      track.innerHTML = items + items;
    });
  }

  /* --- Scroll Reveal Animations --- */
  function initScrollReveal() {
    var revealElements = document.querySelectorAll('.bc-reveal, .bc-reveal-left, .bc-fade-in, .bc-stagger');
    if (!revealElements.length) {
      /* Auto-add bc-reveal to major sections */
      var sections = document.querySelectorAll(
        '.blendsco-stats, .blendsco-quote, .blendsco-about, ' +
        '.blendsco-products, .blendsco-booking, .blendsco-gallery, ' +
        '.blendsco-reviews, .blendsco-social, .blendsco-footer'
      );
      sections.forEach(function(section) {
        section.classList.add('bc-reveal');
      });

      /* Add stagger to grids */
      var grids = document.querySelectorAll(
        '.blendsco-gallery__grid, .blendsco-stats__grid, ' +
        '.blendsco-reviews__grid, .blendsco-products__grid'
      );
      grids.forEach(function(grid) {
        grid.classList.add('bc-reveal-stagger');
      });

      revealElements = document.querySelectorAll('.bc-reveal, .bc-reveal-left');
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });

    revealElements.forEach(function(el) { observer.observe(el); });
  }

  /* --- Language Switcher --- */
  function initLanguageSwitcher() {
    const buttons = document.querySelectorAll('.blendsco-lang__btn');
    if (!buttons.length) return;

    const currentLang = localStorage.getItem('blendsco-lang') || 'fi';
    setLanguage(currentLang);

    buttons.forEach(btn => {
      btn.addEventListener('click', function() {
        const lang = this.dataset.lang;
        setLanguage(lang);
        localStorage.setItem('blendsco-lang', lang);
      });
    });
  }

  function setLanguage(lang) {
    /* Update active button */
    document.querySelectorAll('.blendsco-lang__btn').forEach(btn => {
      btn.classList.toggle('active', btn.dataset.lang === lang);
    });

    /* Update document language for screen readers and SEO */
    document.documentElement.lang = lang;

    /* Show/hide language-specific elements */
    document.querySelectorAll('[data-lang-fi]').forEach(el => {
      if (lang === 'fi') {
        el.textContent = el.dataset.langFi;
      } else {
        el.textContent = el.dataset.langEn;
      }
    });
  }

  /* --- Counter Animation --- */
  function initCounters() {
    const counters = document.querySelectorAll('.blendsco-stats__number');
    if (!counters.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    counters.forEach(counter => observer.observe(counter));
  }

  function animateCounter(el) {
    const text = el.textContent.trim();
    const hasPlus = text.includes('+');
    const hasPercent = text.includes('%');
    const numericValue = parseInt(text.replace(/[^0-9]/g, ''), 10);
    const duration = 1500;
    const start = performance.now();

    function update(now) {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = Math.round(eased * numericValue);

      let display = current.toString();
      if (hasPlus) display += '+';
      if (hasPercent) display += '%';
      el.textContent = display;

      if (progress < 1) requestAnimationFrame(update);
    }

    requestAnimationFrame(update);
  }

  /* --- Smooth scroll for anchor links --- */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(link => {
      link.addEventListener('click', function(e) {
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
          e.preventDefault();
          /* Close nav menu if open */
          const burger = document.getElementById('bcNavBurger');
          const menu = document.getElementById('bcNavMenu');
          if (burger && menu) {
            burger.classList.remove('active');
            menu.classList.remove('active');
            document.body.style.overflow = '';
          }
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  /* --- Hamburger Navigation --- */
  var navRetries = 0;
  function initNav() {
    var burger = document.getElementById('bcNavBurger');
    var menu = document.getElementById('bcNavMenu');

    if (!burger || !menu) {
      burger = document.querySelector('.blendsco-nav__burger');
      menu = document.querySelector('.blendsco-nav__mobile');
    }
    if (!burger || !menu) {
      navRetries++;
      if (navRetries < 10) setTimeout(initNav, 500);
      return;
    }

    function openMenu() {
      burger.classList.add('active');
      menu.classList.add('active');
      burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      /* Trap focus inside mobile menu */
      menu.addEventListener('keydown', trapFocus);
      /* Focus first link after animation */
      var firstLink = menu.querySelector('a, button');
      if (firstLink) setTimeout(function() { firstLink.focus(); }, 100);
    }

    function closeMenu() {
      burger.classList.remove('active');
      menu.classList.remove('active');
      burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      menu.removeEventListener('keydown', trapFocus);
      burger.focus();
    }

    function trapFocus(e) {
      if (e.key !== 'Tab') {
        if (e.key === 'Escape') { closeMenu(); e.preventDefault(); }
        return;
      }
      var focusable = menu.querySelectorAll('a, button, [tabindex]:not([tabindex="-1"])');
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        last.focus(); e.preventDefault();
      } else if (!e.shiftKey && document.activeElement === last) {
        first.focus(); e.preventDefault();
      }
    }

    burger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var isActive = burger.classList.contains('active');
      if (isActive) { closeMenu(); } else { openMenu(); }
    });

    /* Close menu when clicking a mobile link */
    menu.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() {
        closeMenu();
      });
    });

    /* Close button (X) */
    var closeBtn = document.getElementById('bcNavClose');
    if (!closeBtn) {
      closeBtn = document.querySelector('.blendsco-nav__close');
    }
    if (closeBtn) {
      closeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        closeMenu();
      });
    }
  }

  /* --- Cart Drawer + AJAX --- */
  function initCart() {
    var drawer = document.getElementById('bcCartDrawer');
    if (!drawer) return;

    var itemsEl = drawer.querySelector('[data-cart-items]');
    var totalEl = drawer.querySelector('[data-cart-total]');
    var toggle  = document.getElementById('bcCartToggle');

    function open()  { drawer.classList.add('is-open');    drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
    function close() { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');  document.body.style.overflow = ''; }

    function formatMoney(cents) {
      return '€' + (cents / 100).toFixed(2).replace('.', ',');
    }

    function escapeHtml(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function renderCart(cart) {
      var count = cart && cart.item_count ? cart.item_count : 0;

      if (!cart || !cart.items || cart.items.length === 0) {
        itemsEl.innerHTML = '<p class="bc-cart-drawer__empty">Ostoskori on tyhjä.</p>';
      } else {
        itemsEl.innerHTML = cart.items.map(function (item) {
          var img = item.image ? '<img src="' + escapeHtml(item.image) + '" alt="">' : '';
          return '<div class="bc-cart-line" data-line-key="' + escapeHtml(item.key) + '">' +
            '<div class="bc-cart-line__image">' + img + '</div>' +
            '<div class="bc-cart-line__info">' +
              '<div>' +
                '<h3 class="bc-cart-line__title">' + escapeHtml(item.product_title) + '</h3>' +
                '<div class="bc-cart-line__price">' + formatMoney(item.final_line_price) + '</div>' +
              '</div>' +
              '<div class="bc-cart-line__actions">' +
                '<div class="bc-cart-line__qty">' +
                  '<button type="button" data-cart-qty="-1" aria-label="Vähennä">−</button>' +
                  '<span>' + item.quantity + '</span>' +
                  '<button type="button" data-cart-qty="1" aria-label="Lisää">+</button>' +
                '</div>' +
                '<button type="button" class="bc-cart-line__remove" data-cart-remove>Poista</button>' +
              '</div>' +
            '</div>' +
          '</div>';
        }).join('');
      }

      totalEl.textContent = formatMoney(cart ? cart.total_price : 0);
      document.querySelectorAll('.bc-cart-count').forEach(function (el) {
        el.textContent = count;
        if (count === 0) { el.setAttribute('hidden', ''); } else { el.removeAttribute('hidden'); }
      });
    }

    function fetchCart() {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { renderCart(cart); return cart; });
    }

    function addToCart(variantId, quantity) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      });
    }

    function changeLine(key, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function (r) { return r.json(); }).then(renderCart);
    }

    document.addEventListener('click', function (e) {
      var addBtn = e.target.closest('.bc-add-to-cart');
      if (addBtn) {
        e.preventDefault();
        if (addBtn.disabled) return;
        var variantId = addBtn.getAttribute('data-variant-id');
        if (!variantId) return;
        addBtn.disabled = true;
        addToCart(variantId, 1)
          .then(fetchCart)
          .then(function () { open(); addBtn.disabled = false; })
          .catch(function (err) { alert((err && err.description) || 'Lisäys epäonnistui.'); addBtn.disabled = false; });
        return;
      }

      if (e.target.closest('[data-cart-close]')) { close(); return; }

      var qtyBtn = e.target.closest('[data-cart-qty]');
      if (qtyBtn) {
        var line = qtyBtn.closest('[data-line-key]');
        if (!line) return;
        var key = line.getAttribute('data-line-key');
        var current = parseInt(line.querySelector('.bc-cart-line__qty span').textContent, 10);
        var delta = parseInt(qtyBtn.getAttribute('data-cart-qty'), 10);
        changeLine(key, Math.max(0, current + delta));
        return;
      }

      var rmBtn = e.target.closest('[data-cart-remove]');
      if (rmBtn) {
        var line2 = rmBtn.closest('[data-line-key]');
        if (line2) changeLine(line2.getAttribute('data-line-key'), 0);
        return;
      }
    });

    if (toggle) toggle.addEventListener('click', function () { open(); });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    fetchCart();
  }

  /* --- Init all --- */
  function init() {
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!prefersReducedMotion) initMarquee();
    if (!prefersReducedMotion) {
      initScrollReveal();
      initCounters();
    }
    initLanguageSwitcher();
    initSmoothScroll();
    initNav();
    initCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
